<template>
	<div class="eyes" :style="position">
		<Eye ref="left" class="eye eye--left" />
		<Eye ref="right" class="eye eye--right" />
	</div>
</template>

<script>
import xyPos from '@/mixins/xyPos'
import Eye from './Eye'

// Chance to blink per second
const BLINK_CHANCE = 0.15

export default {
	name: 'Eyes',
	methods: {
		eachEye(callback) {
			const { left, right } = this.$refs
			for (const eye of [left, right]) {
				if (eye) callback(eye)
			}
		},
		lookAt(x, y) {
			this.eachEye(eye => eye.lookAt(x, y))
		},
		set(open) {
			this.eachEye(eye => eye.set(open))
		},
		reset() {
			this.eachEye(eye => eye.reset())
		}
	},
	tick() {
		if (Math.random() < BLINK_CHANCE / this.$fps) {
			this.eachEye(eye => eye.wink())
		}
	},
	mixins: [xyPos],
	components: {
		Eye
	}
}
</script>

<style lang="scss" scoped>
.eyes {
	position: absolute;
	top: 0;
	left: 0;
	width: 0;
	height: 0;
}
.eye {
	$offset: 3.25em;
	position: absolute;
	transform: translate3d(-50%, -50%, 0);

	&--left {
		left: -$offset;
	}
	&--right {
		left: $offset;
	}
}
</style>
